import React from "react";

import Container from "components/Layout/Container";
import Header from "components/Layout/Header";
import PublishButton from "components/PublishButton";

import DefaultWorkoutDetails from "pages/Content/Studio/Workouts/WorkoutDetails";

class WorkoutDetails extends React.Component<any> {
  render() {
    return (
      <Container header={<Header controls={<PublishButton />} />}>
        <DefaultWorkoutDetails />
      </Container>
    );
  }
}

export default WorkoutDetails;
